import { OperationVariables, QueryTuple } from '@apollo/client';
import { getApolloLink, useApolloLazyQuery, useCookie } from '@netfront/common-library';

import { IUseEkardoLazyQueryInputVariables } from './useEkardoLazyQuery.interfaces';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useEkardoLazyQuery = <TData = any, TVariables = OperationVariables | undefined>({
  apolloLink,
  options,
  product,
  query,
  token,
}: IUseEkardoLazyQueryInputVariables<TData, TVariables>): QueryTuple<TData, TVariables> => {
  const { getAccessTokenCookie, getTemporaryTokenCookie } = useCookie();

  const accessToken = getAccessTokenCookie();
  const temporaryToken = getTemporaryTokenCookie();

  const authenticationLink = getApolloLink({
    apiName: 'ekardo',
    product,
    token: token ?? accessToken ?? temporaryToken,
  });

  return useApolloLazyQuery({
    apiName: 'ekardo',
    apolloLink: apolloLink ?? authenticationLink,
    options,
    query,
  });
};

export { useEkardoLazyQuery };
